<template>
    <div class="card">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name:'card'
}
</script>

<style lang="less" scoped>
.card{
    background-color: #fff;
    box-shadow:0px 2px 8px 0px rgba(0,0,0,0.06);
    padding: 24px;
}
</style>
